import { DEBUG } from '@src/DEBUG'; 
DEBUG.open ( '/main.ts' );

import 'core-js/es7/reflect';

import { enableProdMode, ApplicationRef } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
// import { AppMakerModule } from './app/app-maker.module';

import { environment } from './environments/environment';
import 'hammerjs';
import { enableDebugTools } from '@angular/platform-browser';

window['CESIUM_BASE_URL'] = '/assets/cesium/';

if (environment.production) {
  enableProdMode();
}

// EVERYTHING is starting from here
DEBUG.log ( '/main.ts', 'BOOTSTRAPPING AppModule' );

platformBrowserDynamic().bootstrapModule(AppModule).catch(err => console.error(err));

/* for debugging tools 
platformBrowserDynamic().bootstrapModule(AppModule)
  .then(module => enableDebugTools(module.injector.get(ApplicationRef).components[0]))
  .catch(err => console.error(err)); */